<template>
  <div class="d-flex align-baseline">
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-icon color="primary" v-on="on" v-bind="attrs" @click="viewItem" class="ml-1 mr-2 my-1">
          mdi-eye
        </v-icon>
      </template>
      <span>View</span>
    </v-tooltip>


<v-tooltip bottom v-if="params.context.parentComponent.tab == 0">
      <template #activator="{ on, attrs }">
        <v-icon
          v-if="permissions && permissions.add"
          color="primary" v-on="on" v-bind="attrs"
          @click="extendItem" class="ml-2 mr-2"
        >mdi-autorenew</v-icon>
      </template>
      <span>Extend Contract</span>
    </v-tooltip>

    <v-tooltip bottom v-if="params.context.parentComponent.tab == 0">
      <template #activator="{ on, attrs }">
        <v-icon
          v-if="permissions && permissions.change"
          color="error" v-on="on" v-bind="attrs"
          @click="closeItem" class="ml-2 mr-2"
        >mdi-close-circle-outline</v-icon>
      </template>
      <span>Close Contract</span>
    </v-tooltip>

    <v-tooltip bottom v-if="params.context.parentComponent.tab == 1">
      <template #activator="{ on, attrs }">
        <v-icon
          v-if="permissions && permissions.add && !params.data.has_been_renewed"
          color="primary" v-on="on" v-bind="attrs"
          @click="renewItem" class="ml-2 mr-2"
        >mdi-autorenew</v-icon>
      </template>
      <span>Renew Contract</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  computed: {
    permissions() {
      return this.params?.context?.parentComponent?.permissions;
    },
  },
  methods: {
    viewItem() {
      this.params.context.parentComponent.viewContract(this.params.data.id);
    },
    editItem() {
      this.params.context.parentComponent.editContract(this.params.data.id);
    },
extendItem() {
      this.params.context.parentComponent.showRenewDialog(this.params.data.id);
    },
    closeItem() {
      this.params.context.parentComponent.showCloseDialog(this.params.data.id);
    },
    renewItem() {
      this.params.context.parentComponent.showRenewDialog(this.params.data.id);
    },
  },
};
</script>

<style></style>
